module.exports = __webpack_public_path__ + "img/download.d0138dae.svg";